import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import FloatingButtons from '../../components/feature/FloatingButtons';

const ServicesPage = () => {
  const whatsappMessage = encodeURIComponent('Merhaba, izmirtentetamir.net web siteniz üzerinden yazıyorum.');

  useEffect(() => {
    document.title = 'Hizmetlerimiz - İzmir Tente Tamir | Tente Tamiri ve Yenileme';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'İzmir Tente Tamir olarak tente tamiri, körüklü tente, mafsallı tente, branda değişimi, tente yenileme ve motorlu tente servisi hizmetleri sunuyoruz. Profesyonel çözümler için bizi arayın.');
    }
  }, []);

  const services = [
    {
      title: 'Tente Tamiri',
      description: 'Her türlü tente arızası için profesyonel tamir hizmeti. Hızlı ve kaliteli çözümler sunuyoruz.',
      icon: 'ri-tools-line',
      link: '/hizmetler/tente-tamiri',
      image: 'https://public.readdy.ai/ai/img_res/eee385385be89ff4b73b119bc4861faf.jpg'
    },
    {
      title: 'Körüklü Tente Tamiri',
      description: 'Körüklü tente sistemlerinin bakım, onarım ve montaj işlemlerini gerçekleştiriyoruz.',
      icon: 'ri-building-line',
      link: '/hizmetler/koruklu-tente-tamiri',
      image: 'https://readdy.ai/api/search-image?query=corrugated%20folding%20awning%20system%20on%20storefront%2C%20accordion%20style%20retractable%20canopy%2C%20modern%20commercial%20building%2C%20clean%20simple%20background%2C%20professional%20installation%2C%20bright%20daylight&width=300&height=250&seq=sp2&orientation=landscape'
    },
    {
      title: 'Mafsallı Tente Tamiri',
      description: 'Mafsallı tente sistemlerinin kurulum, tamir ve bakım hizmetlerini sağlıyoruz.',
      icon: 'ri-home-gear-line',
      link: '/hizmetler/mafsalli-tente-tamiri',
      image: 'https://readdy.ai/api/search-image?query=articulated%20arm%20awning%20with%20mechanical%20joints%20extended%20over%20patio%2C%20modern%20retractable%20system%2C%20clean%20simple%20background%2C%20residential%20setting%2C%20bright%20daylight%2C%20quality%20craftsmanship&width=300&height=250&seq=sp3&orientation=landscape'
    },
    {
      title: 'Branda Değişimi',
      description: 'Yıpranan tente brandalarınızı kaliteli ve dayanıklı malzemelerle yeniliyoruz.',
      icon: 'ri-refresh-line',
      link: '/hizmetler/branda-degisimi',
      image: 'https://readdy.ai/api/search-image?query=worker%20replacing%20awning%20fabric%20canvas%20with%20new%20material%2C%20hands%20installing%20fresh%20striped%20canopy%2C%20clean%20simple%20background%2C%20professional%20service%2C%20bright%20daylight%2C%20quality%20materials&width=300&height=250&seq=sp4&orientation=landscape'
    },
    {
      title: 'Tente Yenileme',
      description: 'Eski tentelerinizi modern ve estetik görünümlü yeni sistemlerle değiştiriyoruz.',
      icon: 'ri-recycle-line',
      link: '/hizmetler/tente-yenileme',
      image: 'https://readdy.ai/api/search-image?query=before%20and%20after%20awning%20renovation%2C%20old%20canopy%20being%20replaced%20with%20modern%20new%20system%2C%20clean%20simple%20background%2C%20transformation%20concept%2C%20bright%20daylight%2C%20professional%20upgrade&width=300&height=250&seq=sp5&orientation=landscape'
    },
    {
      title: 'Manuel ve Motorlu Tente Servisi',
      description: 'Manuel ve motorlu tente sistemlerinin kurulum, bakım ve onarım hizmetlerini sunuyoruz.',
      icon: 'ri-settings-3-line',
      link: '/hizmetler/manuel-motorlu-tente-servisi',
      image: 'https://readdy.ai/api/search-image?query=motorized%20awning%20with%20electric%20motor%20and%20remote%20control%2C%20automated%20retractable%20canopy%20system%2C%20clean%20simple%20background%2C%20modern%20technology%2C%20bright%20daylight%2C%20smart%20home%20integration&width=300&height=250&seq=sp6&orientation=landscape'
    },
    {
      title: 'Bioklimatik Pergola Tente',
      description: 'Akıllı havalandırma sistemli bioklimatik pergola kurulum ve bakım hizmetleri.',
      icon: 'ri-sun-line',
      link: '/hizmetler/bioklimatik-pergola-tente',
      image: 'https://readdy.ai/api/search-image?query=modern%20bioclimatic%20pergola%20with%20adjustable%20louvers%20on%20terrace%2C%20aluminum%20slats%20roof%20system%2C%20clean%20simple%20background%2C%20luxury%20outdoor%20living%2C%20bright%20daylight%2C%20contemporary%20architecture&width=300&height=250&seq=sp7&orientation=landscape'
    },
    {
      title: 'Otomatik Pergola Tente',
      description: 'Motorlu otomatik pergola sistemlerinin montaj, tamir ve bakım işlemleri.',
      icon: 'ri-remote-control-line',
      link: '/hizmetler/otomatik-pergola-tente',
      image: 'https://readdy.ai/api/search-image?query=automatic%20motorized%20pergola%20with%20retractable%20roof%20on%20patio%2C%20electric%20opening%20system%2C%20clean%20simple%20background%2C%20modern%20outdoor%20space%2C%20bright%20daylight%2C%20smart%20automation&width=300&height=250&seq=sp8&orientation=landscape'
    },
    {
      title: 'Kasetli Tente',
      description: 'Koruyucu kasetli tente sistemlerinin kurulum ve onarım hizmetleri.',
      icon: 'ri-inbox-line',
      link: '/hizmetler/kasetli-tente',
      image: 'https://readdy.ai/api/search-image?query=cassette%20awning%20with%20protective%20housing%20box%20mounted%20on%20wall%2C%20enclosed%20retractable%20canopy%20system%2C%20clean%20simple%20background%2C%20modern%20design%2C%20bright%20daylight%2C%20weather%20protection&width=300&height=250&seq=sp9&orientation=landscape'
    },
    {
      title: 'T-Modül Tente',
      description: 'Modüler tasarımlı T-Modül tente sistemlerinin montaj ve bakım hizmetleri.',
      icon: 'ri-layout-grid-line',
      link: '/hizmetler/t-modul-tente',
      image: 'https://readdy.ai/api/search-image?query=T-module%20awning%20system%20with%20vertical%20drop%20fabric%20on%20storefront%2C%20modular%20canopy%20design%2C%20clean%20simple%20background%2C%20commercial%20application%2C%20bright%20daylight%2C%20modern%20architecture&width=300&height=250&seq=sp10&orientation=landscape'
    },
    {
      title: 'Zip Perde Tente',
      description: 'Rüzgar dayanıklı zip perde tente sistemlerinin kurulum ve tamir işlemleri.',
      icon: 'ri-shield-line',
      link: '/hizmetler/zip-perde-tente',
      image: 'https://readdy.ai/api/search-image?query=zip%20screen%20awning%20with%20side%20rails%20and%20zippered%20edges%2C%20vertical%20roller%20blind%20system%2C%20clean%20simple%20background%2C%20windproof%20design%2C%20bright%20daylight%2C%20modern%20exterior&width=300&height=250&seq=sp11&orientation=landscape'
    },
    {
      title: 'Şeffaf Stor Tente',
      description: 'Görüş korumalı şeffaf stor tente sistemlerinin montaj ve bakım hizmetleri.',
      icon: 'ri-eye-line',
      link: '/hizmetler/seffaf-stor-tente',
      image: 'https://readdy.ai/api/search-image?query=transparent%20clear%20roller%20blind%20awning%20on%20balcony%2C%20see-through%20PVC%20screen%20system%2C%20clean%20simple%20background%2C%20weather%20protection%20with%20view%2C%20bright%20daylight%2C%20modern%20residential&width=300&height=250&seq=sp12&orientation=landscape'
    },
    {
      title: 'Fermuarlı Şeffaf Tente',
      description: 'Fermuarlı şeffaf tente sistemlerinin kurulum, onarım ve bakım işlemleri.',
      icon: 'ri-contrast-drop-line',
      link: '/hizmetler/fermuar-seffaf-tente',
      image: 'https://readdy.ai/api/search-image?query=zippered%20transparent%20awning%20enclosure%20for%20terrace%2C%20clear%20PVC%20panels%20with%20zipper%20system%2C%20clean%20simple%20background%2C%20all-weather%20protection%2C%20bright%20daylight%2C%20outdoor%20living&width=300&height=250&seq=sp13&orientation=landscape'
    },
    {
      title: 'Fransız Tente',
      description: 'Klasik tasarımlı Fransız tente sistemlerinin montaj ve tamir hizmetleri.',
      icon: 'ri-store-line',
      link: '/hizmetler/fransiz-tente',
      image: 'https://readdy.ai/api/search-image?query=French%20style%20curved%20awning%20with%20elegant%20scalloped%20valance%20on%20cafe%2C%20classic%20dome%20canopy%20design%2C%20clean%20simple%20background%2C%20traditional%20architecture%2C%20bright%20daylight%2C%20vintage%20charm&width=300&height=250&seq=sp14&orientation=landscape'
    },
    {
      title: 'Karpuz Tente',
      description: 'Dekoratif karpuz tente modellerinin kurulum ve bakım hizmetleri.',
      icon: 'ri-home-smile-line',
      link: '/hizmetler/karpuz-tente',
      image: 'https://readdy.ai/api/search-image?query=watermelon%20style%20curved%20awning%20with%20rounded%20dome%20shape%20on%20window%2C%20semicircular%20canopy%20design%2C%20clean%20simple%20background%2C%20decorative%20exterior%2C%20bright%20daylight%2C%20charming%20architecture&width=300&height=250&seq=sp15&orientation=landscape'
    }
  ];

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Header />
      <FloatingButtons />

      <section className="pt-20 pb-8 md:pt-24 md:pb-12 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto text-center">
          <span className="text-xs font-medium text-gray-600 uppercase tracking-wide">Profesyonel Çözümler</span>
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mt-2 mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
            Tente Tamir Hizmetlerimiz
          </h1>
          <p className="text-sm md:text-base text-gray-600 max-w-3xl mx-auto leading-relaxed">
            İzmir genelinde konut ve ticari alanlara yönelik kapsamlı tente hizmetleri sunuyoruz. 
            Deneyimli ekibimiz ve kaliteli malzemelerimizle her türlü tente ihtiyacınıza profesyonel çözümler üretiyoruz.
          </p>
        </div>
      </section>

      <section className="pb-10 md:pb-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
            {services.map((service, index) => (
              <Link
                key={index}
                to={service.link}
                className="group cursor-pointer"
              >
                <div className="bg-gray-50 rounded-xl overflow-hidden mb-2 md:mb-3 w-full h-32 md:h-40">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                    loading="lazy"
                  />
                </div>
                <h3 className="text-xs md:text-sm font-bold text-gray-900 mb-1">{service.title}</h3>
                <p className="text-xs text-gray-600 hidden md:block">{service.description}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Detailed Service Information */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-12">
            <div>
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
                İzmir Tente Tamir Firmaları
              </h2>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Son yıllarda dış mekan kullanımının artmasıyla birlikte tente sistemlerine olan talep de önemli ölçüde yükselmiştir. Bu durum, İzmir'de tente bakım ve onarım hizmeti veren firma sayısının da artmasına neden olmuştur.
              </p>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Tente sistemleri mekanik parçalar içerdiği için yapılan işlemlerin uzman kişiler tarafından gerçekleştirilmesi gerekir. Yanlış yapılan bir müdahale sistemin tamamen kullanılamaz hale gelmesine neden olabilir.
              </p>
              <p className="text-sm md:text-base text-gray-700 mb-6 leading-relaxed">
                Her tente sistemi farklı bir mekanik yapıya sahip olabilir. Bu nedenle onarım süreci öncesinde sistemin detaylı şekilde incelenmesi gerekir. Doğru analiz sayesinde hem daha hızlı hem de daha etkili bir tamir süreci yürütülebilir.
              </p>
            </div>
            <div>
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Profesyonel Tente Tamir Ne Kadar Sürer?
              </h3>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Tente tamir süresi, sistemde oluşan arızanın türüne göre değişiklik gösterebilir. Basit mekanik ayar işlemleri genellikle kısa sürede tamamlanabilir. Ancak motor arızası veya kumaş değişimi gibi işlemler biraz daha uzun sürebilir.
              </p>
              <div className="bg-white rounded-xl p-6 shadow-md">
                <h4 className="text-lg font-semibold text-gray-900 mb-4">Tamir Süreci</h4>
                <ul className="space-y-3">
                  <li className="flex items-start space-x-3">
                    <span className="w-6 h-6 bg-gray-900 text-white rounded-full flex items-center justify-center text-xs flex-shrink-0">1</span>
                    <span className="text-sm text-gray-700">Arıza tespiti</span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <span className="w-6 h-6 bg-gray-900 text-white rounded-full flex items-center justify-center text-xs flex-shrink-0">2</span>
                    <span className="text-sm text-gray-700">Gerekli ekipman ve parçaların hazırlanması</span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <span className="w-6 h-6 bg-gray-900 text-white rounded-full flex items-center justify-center text-xs flex-shrink-0">3</span>
                    <span className="text-sm text-gray-700">Tamir işleminin uygulanması</span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <span className="w-6 h-6 bg-gray-900 text-white rounded-full flex items-center justify-center text-xs flex-shrink-0">4</span>
                    <span className="text-sm text-gray-700">Sistem kontrolü ve test</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl p-8 shadow-md mb-12">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
              İzmir Tente Tamir Hizmet - Fiyat Bilgileri
            </h2>
            <p className="text-sm md:text-base text-gray-700 mb-6 leading-relaxed">
              Tente tamir hizmetlerinde fiyatlar çeşitli faktörlere bağlı olarak değişiklik gösterebilir. Tente sisteminin modeli, arızanın türü ve kullanılacak parçalar fiyat üzerinde etkili olabilir. Bu nedenle her sistem için sabit bir fiyat belirlemek çoğu zaman mümkün değildir.
            </p>
            <p className="text-sm md:text-base text-gray-700 mb-6 leading-relaxed">
              Kaliteli parçalar kullanıldığında sistem daha uzun süre sorunsuz şekilde kullanılabilir. Bu da uzun vadede maliyet avantajı sağlar. Müşterilerimize şeffaf fiyatlandırma sunmaya özen gösteririz. Yapılacak işlemler önceden açıklanır ve süreç hakkında bilgilendirme yapılır.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="bg-gray-50 rounded-lg p-4">
                <h4 className="text-sm font-semibold text-gray-900 mb-2">Tente Modeli</h4>
                <p className="text-xs text-gray-600">Sistemin türü ve karmaşıklığı</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-4">
                <h4 className="text-sm font-semibold text-gray-900 mb-2">Arıza Kapsamı</h4>
                <p className="text-xs text-gray-600">Hasarın büyüklüğü ve türü</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-4">
                <h4 className="text-sm font-semibold text-gray-900 mb-2">Parça Değişimi</h4>
                <p className="text-xs text-gray-600">Yedek parça gereksinimi</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-4">
                <h4 className="text-sm font-semibold text-gray-900 mb-2">Kumaş Durumu</h4>
                <p className="text-xs text-gray-600">Branda yenileme ihtiyacı</p>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl p-6 shadow-md">
              <div className="w-12 h-12 bg-gray-900 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-tools-line text-white text-xl"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">Tente Tamir İşlemleri</h3>
              <ul className="space-y-2 text-sm text-gray-700">
                <li>• Tente mekanizması arıza tespiti</li>
                <li>• Kumaş yenileme veya onarım</li>
                <li>• Motorlu tente sistemleri bakımı</li>
                <li>• Mekanik parça değişimi</li>
                <li>• Tente ayar ve bakım işlemleri</li>
              </ul>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-md">
              <div className="w-12 h-12 bg-gray-900 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-map-pin-line text-white text-xl"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">Hizmet Alanlarımız</h3>
              <ul className="space-y-2 text-sm text-gray-700">
                <li>• Konut tente sistemleri</li>
                <li>• Restoran ve kafe tentleri</li>
                <li>• Mağaza ve işletme tentleri</li>
                <li>• Otel ve konaklama tesisleri</li>
                <li>• Ticari alan tente sistemleri</li>
              </ul>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-md">
              <div className="w-12 h-12 bg-gray-900 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-shield-check-line text-white text-xl"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">Kalite Garantimiz</h3>
              <ul className="space-y-2 text-sm text-gray-700">
                <li>• Profesyonel ekipman kullanımı</li>
                <li>• Deneyimli teknisyen kadrosu</li>
                <li>• Kaliteli yedek parça</li>
                <li>• İşçilik garantisi</li>
                <li>• Müşteri memnuniyeti odaklı</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="py-10 md:py-16 px-4 sm:px-6 lg:px-8 bg-gray-50">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
            Hemen Teklif Alın
          </h2>
          <p className="text-sm text-gray-600 mb-6">
            Tente ihtiyaçlarınız için ücretsiz keşif ve fiyat teklifi alabilirsiniz
          </p>
          <div className="flex flex-row gap-3 justify-center">
            <a
              href="tel:+905513723512"
              className="px-5 py-2.5 bg-gray-900 hover:bg-gray-800 text-white text-xs font-semibold rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              Hemen Ara
            </a>
            <a
              href={`https://wa.me/905513723512?text=${whatsappMessage}`}
              target="_blank"
              rel="noopener noreferrer"
              className="px-5 py-2.5 border-2 border-gray-900 hover:bg-gray-50 text-gray-900 text-xs font-semibold rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              WhatsApp ile Yaz
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ServicesPage;
